module.exports = __webpack_public_path__ + "static/media/frequent_airing.128a037a.svg";